import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { theme } from "./theme";
/**
 * Generate a responsive css value which generates
 * values based on theme props.
 * @param styleKey string
 * @param themeKey string
 */

export function responsiveThemeStyle(styleKey, themeKey) {
  return function (value) {
    var _ref5;

    var modifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultModifier;
    var themeValues = theme[themeKey];

    if (typeof value === 'string' || typeof value === 'number') {
      return _defineProperty({}, styleKey, modifier(themeValues[value]));
    }

    var _ref2 = value,
        phone = _ref2.phone,
        tablet = _ref2.tablet,
        desktop = _ref2.desktop;
    return _ref5 = {}, _defineProperty(_ref5, styleKey, phone && modifier(themeValues[phone])), _defineProperty(_ref5, theme.mediaQueries.tablet, tablet && _defineProperty({}, styleKey, modifier(themeValues[tablet]))), _defineProperty(_ref5, theme.mediaQueries.desktop, desktop && _defineProperty({}, styleKey, modifier(themeValues[desktop]))), _ref5;
  };
}

var defaultModifier = function defaultModifier(value) {
  return value;
};